<template>
    <div class="expert-notes">
        <label class="label">
            <span class="title">{{ $t('notes') }}</span>
            <span class="optional">(Optional)</span>
        </label>
        <textarea class="notes-textarea" placeholder="Enter your note..." :maxlength="maxLength" rows="6"
            v-model="localValue" :disabled="disabled" />
        <div class="counter">{{ charCount }} / {{ maxLength }} characters</div>
    </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue'

const props = defineProps({
    modelValue: { type: String, default: '' },
    maxLength: { type: Number, default: 1000 },
    disabled: { type: Boolean, default: false },
})

const emit = defineEmits(['update:modelValue'])

const localValue = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const charCount = computed(() => (localValue.value || '').length)
</script>

<style scoped>
.expert-notes {
    margin-top: 12px;
    border-top: 1px solid #dee2e6 !important;
    padding: 2rem 0;
}

.label {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
}

.title {
    color: #164B6C;
    font-weight: 700;
}

.optional {
    color: #6b7280;
    font-size: 0.8em;
}

.info-icon {
    color: #164B6C;
}

.notes-textarea {
    width: 100%;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    padding: 8px;
    font-size: 0.8rem;
    resize: vertical;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
}

.notes-textarea:focus,
.notes-textarea:focus-visible {
    outline: none;
    box-shadow: none;
    border-color: #cbd5e1;
}

.notes-textarea::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
.notes-textarea::-webkit-scrollbar-track {
    background: transparent;
}
.notes-textarea::-webkit-scrollbar-thumb {
    background-color: #cbd5e1; 
    border-radius: 8px;
    border: 2px solid transparent;
    background-clip: content-box;
}
.notes-textarea::-webkit-scrollbar-thumb:hover {
    background-color: #94a3b8;
}

.counter {
    text-align: right;
    color: #6b7280;
    font-size: 0.75rem;
    margin-top: 4px;
}
</style>